import {Avatar, Button, Input, Modal, Select, Table, Tag} from 'antd';
import {inject, observer} from 'mobx-react';
import * as React from 'react';
import {Helmet} from 'react-helmet';
import Card, {CardBody, CardHeader} from '../../components/Card';
import Flex from '../../components/Flex';
import Layout, {Main} from '../../components/Layout';
import {TeamsListType} from '../../models/TeamsListModel';

const Search = Input.Search;

// tslint:disable
interface WithInjectedProps {
  teamsList: TeamsListType;
}

@inject('teamsList')
@observer
class Teams extends React.Component<
  {},
  {filterByField: string; isDeleting: boolean}
> {
  state = {
    filterByField: 'name',
    isDeleting: false
  };

  componentDidMount() {
    this._loadData({limit: 12, offset: 0});
  }

  _loadData = (params: any) => {
    this.withInjectedProps.teamsList.loadEntries(params);
  };

  _handleDataTableChange = (pagination: any, filters: any, sorter: any) => {
    // const pager = this.withInjectedProps.teamsList.pagination;
    const {pageSize, current} = pagination;
    this._loadData({limit: pageSize, offset: pageSize * (current - 1)});
  };

  _handleSearch = (value: string) => {
    const params = {
      limit: 12,
      offset: 0,
      ...(value && {
        [this.state.filterByField]: value.trim().toLowerCase()
      })
    };
    this.withInjectedProps.teamsList.clearEntries();
    this._loadData(params);
  };

  _handleFilterFieldSelect = (field: string) => {
    if (field === 'domainName' || field === 'name' || field === 'id') {
      this.setState({filterByField: field});
    }
  };

  teamItemData = (data: any) => {
    const {id, avatar, name, email, serviceType, owner, members} = data;
    const {setCurrentDeleteTeam} = this.withInjectedProps.teamsList;

    return {
      key: id,
      id: id,
      avatar: <Avatar shape="square" src={avatar} />,
      owner: (
        <span title={owner.firstName + ' ' + owner.lastName}>
          <Avatar shape="circle" src={owner.avatar} />
        </span>
      ),
      members: members.length,
      name: name,
      actions: (
        <div>
          <Button type="primary" href={`/teams/${id}`}>
            Details
          </Button>
          <Button
            size="small"
            type="danger"
            style={{marginLeft: 10}}
            onClick={() => {
              this.setState({isDeleting: !this.state.isDeleting});
              setCurrentDeleteTeam(data);
            }}
          >
            Delete
          </Button>
        </div>
      ),
      email: email,
      serviceType: (
        <Tag color="blue">{serviceType ? serviceType : 'NotSet'}</Tag>
      )
    };
  };

  private _renderModalDeleteTeam = () => {
    const {deletingTeam} = this.withInjectedProps.teamsList;

    return (
      <Modal
        title={
          <span style={{fontWeight: 'bold', color: 'red'}}>
            PLEASE ATTENTION!
          </span>
        }
        visible={this.state.isDeleting}
        onCancel={() => this.setState({isDeleting: !this.state.isDeleting})}
        onOk={() => {
          if (deletingTeam) {
            this.withInjectedProps.teamsList.deleteTeam(deletingTeam.id);
            this.setState({isDeleting: false});
          }
        }}
        okText="Confirm"
        okButtonDisabled={this.state.isDeleting}
        style={{top: 20}}
      >
        <p>
          Are you sure delete{' '}
          <span style={{color: 'red'}}>
            {deletingTeam ? deletingTeam.name : ''}
          </span>{' '}
          team ?
        </p>
      </Modal>
    );
  };

  public render() {
    const columns = this._dataHeaderTable();
    const {entries, isLoading, pagination} = this.withInjectedProps.teamsList;
    const arrayTeams = Array.from(entries.values());
    const dataSource = this._cvtDataSource(arrayTeams);
    const paging = {
      pageSize: pagination.limit,
      current: pagination.current,
      total: pagination.total,
      defaultCurrent: 1
    };
    return (
      <React.Fragment>
        <Helmet>
          <title>Manage Team</title>
        </Helmet>
        <Layout>
          <Main>
            <Card>
              <CardHeader>Manage Teams</CardHeader>
              {this._renderModalDeleteTeam()}
              <CardBody>
                <Flex justify="flex-end" style={{marginBottom: 16}}>
                  <Select
                    style={{flexBasis: 120}}
                    onSelect={this._handleFilterFieldSelect}
                    defaultValue="name"
                  >
                    <Select.Option title="By name" value="name">
                      By name
                    </Select.Option>
                    <Select.Option title="By ID" value="id">
                      By id
                    </Select.Option>
                    <Select.Option title="By subdomain" value="domainName">
                      By subdomain
                    </Select.Option>
                  </Select>
                  <Search
                    placeholder={`Enter ${this.state.filterByField}`}
                    onSearch={value => this._handleSearch(value)}
                    allowClear={true}
                    style={{width: 300}}
                  />
                </Flex>
                <Table
                  bordered={true}
                  dataSource={dataSource}
                  columns={columns}
                  loading={isLoading}
                  onChange={this._handleDataTableChange}
                  pagination={paging}
                />
              </CardBody>
            </Card>
          </Main>
        </Layout>
      </React.Fragment>
    );
  }
  _dataHeaderTable = () => {
    return [
      {
        title: 'Id',
        dataIndex: 'id',
        key: 'id'
      },
      {
        title: 'Avatar',
        dataIndex: 'avatar',
        key: 'avatar'
      },
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name'
      },
      {
        title: 'Owner',
        dataIndex: 'owner',
        key: 'owner'
      },
      {
        title: 'Members',
        dataIndex: 'members',
        key: 'members'
      },
      {
        title: 'Email',
        dataIndex: 'email',
        key: 'email'
      },
      {
        title: 'Service',
        dataIndex: 'serviceType',
        key: 'serviceType'
      },
      {
        title: 'Actions',
        dataIndex: 'actions',
        key: 'actions'
      }
    ];
  };

  _cvtDataSource = (entries: any) => {
    return entries.map(
      (
        {id, name, email, avatar, serviceType, owner, members}: any,
        idx: number
      ) => {
        return this.teamItemData({
          id,
          name,
          avatar,
          email,
          serviceType,
          owner,
          members
        });
      }
    );
  };

  get withInjectedProps() {
    return this.props as WithInjectedProps;
  }
}

export default Teams;



// WEBPACK FOOTER //
// ./src/pages/Teams/Teams.tsx